import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useNavigate } from 'react-router'
import { useTranslate } from '@repo/unicity'
import { ActionButton } from '@/core/components'
import { useBuyNowText } from '@/core/feelgreat/feelgreat.hooks'
import LemonIcon from './assets/lemon.svg?react'

/**
 * Empty-cart state shown when the user has cleared every line from the
 * checkout cart. Lives in the shared default/cart module so any country
 * checkout can reuse it.
 */
const CartEmpty = () => {
    const { translate } = useTranslate()
    const buyNowText = useBuyNowText()
    const navigate = useNavigate()

    return (
        <Stack pt="40px" alignItems="center" px={{ xs: '20px', sm: 3 }} sx={{ boxSizing: 'border-box' }} data-testid="cart-empty-stack">
            <Card
                sx={{
                    width: '100%',
                    maxWidth: { xs: '100%', sm: '540px', md: 770 },
                    borderRadius: '12px'
                }}
                data-testid="cart-empty-card-lemon-icon">
                <CardContent sx={{ padding: { xs: '32px 20px', sm: '60px' } }} data-testid="cart-empty-card-content-lemon-icon">
                    <Stack alignItems="center" width="100%" spacing="30px" data-testid="cart-empty-stack-lemon-icon">
                        <LemonIcon width={89} height={88} data-testid="cart-empty-lemon-icon" />

                        <Typography variant="h3" sx={{ color: '#003764', textAlign: 'center' }} data-testid="cart-empty-typography-empty-cart-title">
                            {translate('empty_cart_title')}
                        </Typography>

                        <Typography
                            variant="body2"
                            sx={{
                                textAlign: 'center',
                                color: '#003764',
                                maxWidth: '420px'
                            }}
                            data-testid="cart-empty-typography-empty-cart-description">
                            {translate('empty_cart_description')}
                        </Typography>

                        <Box sx={{ width: '100%', maxWidth: '246px' }} data-testid="cart-empty-box-action-button">
                            <ActionButton
                                text={buyNowText}
                                onClick={() => navigate('/products')}
                                variant="dark"
                                width="100%"
                                data-testid="cart-empty-action-button"
                            />
                        </Box>
                    </Stack>
                </CardContent>
            </Card>
        </Stack>
    )
}

export default CartEmpty
export { CartEmpty }
